<template>
    <v-layout wrap row justify-center fill-height align-center style="margin-top:10%">
      <v-flex xs12 sm6 class="text-xs-center">
        <img class="logo" src="https://s3.us-east-2.amazonaws.com/binxudata/logo.gif">
      </v-flex>
    <v-flex xs12 class="text-xs-right">
      <v-btn style="margin-top:-10%;margin-right:10%" dark color="black" to="/welcome">Learn More</v-btn>
    </v-flex>
    </v-layout>
</template>

<script>
export default {
  name: 'Landing'
}
</script>
<style lang="scss" scoped>
  .logo {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
</style>



// WEBPACK FOOTER //
// src/views/Landing.vue